import { render, staticRenderFns } from "./PopupDialog.vue?vue&type=template&id=ff58fcf6&scoped=true&"
import script from "./PopupDialog.vue?vue&type=script&lang=js&"
export * from "./PopupDialog.vue?vue&type=script&lang=js&"
import style0 from "./PopupDialog.vue?vue&type=style&index=0&id=ff58fcf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff58fcf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ff58fcf6')) {
      api.createRecord('ff58fcf6', component.options)
    } else {
      api.reload('ff58fcf6', component.options)
    }
    module.hot.accept("./PopupDialog.vue?vue&type=template&id=ff58fcf6&scoped=true&", function () {
      api.rerender('ff58fcf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2xEawGlC2bVJ3/JS/comp/PopupDialog.vue"
export default component.exports